/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.ProgressBar = function() {
    var doc = document;
    
    var container = doc.createElement( "div");
    var txt = doc.createElement( "p");
    var bar = doc.createElement( "div");
    var fill = doc.createElement( "span");
    
    container.className = "barContainer";
    bar.className = "progressFX-bar";
    txt.className = "progress-text";
    txt.textContent = "P";
    fill.textContent = "P";
    
    bar.appendChild( fill);
    container.appendChild( txt);
    container.appendChild( bar);
    
    return {
        bar: container,
        text: txt,
        fill: function( value) {
            fill.style.width = ( value * bar.clientWidth) + "px";
        }
    };
};
    

